import { render, staticRenderFns } from "./MobileInformationCard.vue?vue&type=template&id=5b00f90e&scoped=true&"
import script from "./MobileInformationCard.vue?vue&type=script&lang=js&"
export * from "./MobileInformationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00f90e",
  null
  
)

export default component.exports